import React from 'react'

function ExternalRedirect( { url } ) {
    window.location.replace(url);
    //FIXME: style this
    return <>You will be redirected to {url}</>
}

export default ExternalRedirect
